import dzLogoPng from '../assets/logo/DZ-Logo.png';

/** Bundled logo for in-app use (Loader, Login). Tab icon uses `public/favicon.png` — after editing `src/assets/logo/DZ-Logo.png`, run `pnpm sync:favicon`. */
export const BRAND_LOGO_URL = dzLogoPng;
